import { isNil } from 'lodash';
import {
  isAddressComponent,
  isDateComponent,
  isEmailComponent,
  isNumberComponent,
  isTagComponent,
  isTextComponent,
} from '@shared/scenes/workflows/utils';
import { AddressField } from './AddressField';
import { DateField } from './DateField';
import { EmailField } from './EmailField';
import { NumberField } from './NumberField';
import { TagField } from './TagField';
import { TextField } from './TextField';

export function RelatedLookupField(
  entity: MBAPI.WorkflowEntity,
  component: MBAPI.WorkflowTemplate_components_RelatedCardLookupComponent,
  refs: MBAPI.ListWorkflowEntitiesQuery_list_refs,
): NumberField | DateField | TextField | AddressField | EmailField | TagField | null {
  const relatedCardWorkflowTemplate = refs.workflowTemplateRefs?.find(
    wft => wft.id === component.lookupWorkflowTemplateId,
  );
  const relatedCardComponent = entity.fields?.[component.relatedCardComponentId];
  const firstCard = relatedCardComponent?.[0];
  const relatedCard = refs.workflowEntityRefs?.find(we => we.id === firstCard?.id);
  const data = relatedCard?.fields?.[component.lookupComponentId];
  const lookupComponent = relatedCardWorkflowTemplate?.components.find(
    c => c.id === component.lookupComponentId,
  );

  if (isNil(lookupComponent)) {
    return null;
  }
  if (isNumberComponent(lookupComponent)) {
    return NumberField.fromFieldJson(data, lookupComponent.format);
  }
  if (isDateComponent(lookupComponent)) {
    return DateField.fromFieldJson(data);
  }
  if (isTextComponent(lookupComponent)) {
    return TextField.fromFieldJson(data, { multiline: lookupComponent.multiline });
  }
  if (isAddressComponent(lookupComponent)) {
    return AddressField.fromFieldJson(data);
  }
  if (isEmailComponent(lookupComponent)) {
    return EmailField.fromFieldJson(data);
  }
  if (isTagComponent(lookupComponent)) {
    return TagField.fromFieldJson(
      data,
      component.id,
      lookupComponent.options ?? [],
      lookupComponent.multiselect ?? false,
      lookupComponent.addAdditionalValues ?? false,
    );
  }
  return null;
}
